var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:'btn-' + _vm.variant + ' btn-' + _vm.size + ' ' + _vm.custom_class,attrs:{"id":_vm.id,"type":_vm.type,"disabled":_vm.loading || _vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.loading)?_c('i',{staticClass:"fal fa-spinner-third spin mr-1"}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }